export const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);

export const ownValue = <T>(record: Readonly<Record<string, T>> | null | undefined, key: string): T | undefined =>
	record && Object.hasOwn(record, key) ? record[key] : undefined;
